import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, IconButton } from '@material-ui/core';
import BasicButton from 'Components/common/BasicButton';
import { ArrowBackIos } from '@material-ui/icons';
import { getOrderReport } from 'Actions/userCenter';
import { openNotification } from 'Actions/notification';
import BasicInput from '../common/BasicInput';
import { T } from 'Actions/translate';
import util from 'Utils/commonUtil';
import { loadLanguage } from 'Utils/jwtUtil';

class OrderReport extends Component {

	state = {
		isEmail: true,
		loading: false,
		email: '',
		beginTime: '',
		endTime: ''
	}

	componentWillMount() {
    	const { email } = this.props;
		this.setState({ email: email });
	}

	handleChange = (name, value) => {
		if(name === 'email'){
			const re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
			const isEmail = re.test(value);

			if(value !== ''){
				this.setState({ isEmail: isEmail });
			} else {
				this.setState({ isEmail: false });
			}
		}
		this.setState({ [name]: value });
	};

	submitReport = () => {
		const params = {};
		params.email =  this.state.email;
		params.beginTime =  this.state.beginTime;
		params.endTime =  this.state.endTime;

		if(this.state.beginTime > this.state.endTime){
			this.props.openNotification(T('notification_order_start_time_shall_not_be_greater_than_the_end_time'), 'danger');
		} else {
			this.setState({
				loading: true,
				isEmail: false,
			 });
			this.props.getOrderReport(params).then(() => {
				this.setState({
					isEmail: false,
					loading: false,
					email: '',
					beginTime: '',
					endTime: ''
				});

				this.props.openNotification(T('notification_order_report_has_been_sent_to_the_mailbox'), 'success');

				this.props.history.push('/userCenter');
			}).catch(err => {
				if(err.status === 'no_content') {
					this.setState({
						loading: false,
						isEmail: true,
					});
				}
			}).finally(() => {
				this.setState({
					loading: false,
					isEmail: true,
				});
			});
		}
	}

	render() {
		const { isEmail, email, loading } = this.state;
		let lang = loadLanguage();
		return (
			<div className='order-report'>
				<Grid className='container-max-width is-fixed ship-to-head' container spacing={0} justify={'space-evenly'}>
					<Grid className='back-icon' item xs={3}>
						<IconButton color='inherit' onClick={() => this.props.history.push('/userCenter')}>
							<ArrowBackIos/>
						</IconButton>
					</Grid>

					<Grid className={ util.getClassName({
						'page-title': true && lang !== 'EN',
						'en-page-title': true && lang === 'EN'
					}) } item xs={9}>
							<span>{T('user_center_order_report')}</span>
					</Grid>
				</Grid>

				<div className="content ">
					<section className="content-box">
						<span className='order-report-title'>{T('user_center_order_choose_time')}</span>
						<Grid container spacing={0} justify={'center'}>
							<div className='date-time'>
								<BasicInput
									title={'beginTime'}
									type={'date'}
									inputValid={this.handleChange}
								/>
							</div>
							<div className='date-text'>{T('user_center_period')}</div>
							<div className='date-time'>
								<BasicInput
									title={'endTime'}
									type={'date'}
									inputValid={this.handleChange}
								/>
							</div>
						</Grid>
					</section>
				</div>

				<div className="order-report-content">
					<section className="content-box">
						<span className='order-report-title'>{T('user_center_report_send_to')}</span>
						<Grid container spacing={0} justify={'center'}>
							<Grid item xs={12}>
								<BasicInput
									title={'email'}
									placeholder={T('enter_email_receive_report')}
									defaultValue={email}
									inputValid={this.handleChange}
								/>
							</Grid>
						</Grid>
					</section>
				</div>

				<Grid className='confirm-select' container spacing={0} justify={'center'}>
					<Grid item xs={4}>
						<BasicButton className='btn-width' type="primary" loading={loading} disabled={isEmail ? false : true} onClickOfSingleTap={this.submitReport}>
							<span>{T('user_center_confirm_send')}</span>
						</BasicButton>
					</Grid>
				</Grid>
			</div>
		);
	}
}

const mapStateToProps = state => {
	const { userCenter, localData } = state;
	return {
		orderReport: userCenter.orderReport,
		email: localData.roleType === 0 ? localData.customerEmail : localData.email ? localData.email : '',
	};
};

const mapDispatchToProps = {
	getOrderReport,
	openNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderReport);
